import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";

import "./ChannelMap.css";

import iso from "iso-3166-1";
import L from "leaflet";
import React, { Component } from "react";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import { Link } from "react-router-dom";

import MarkerClusterGroup from "../components/MarkerClusterGroup";
import pin from "../images/svmappin.png";
import disabledPin from "../images/svmappindisable.png";

const normalIcon = (icon, channel) =>
  L.icon({
    iconUrl: icon,
    iconSize: [20, 30],
    iconAnchor: [10, 30],
    popupAnchor: [0, -30]
  });

const emphasizeIcon = (icon, channel) =>
  L.icon({
    iconUrl: icon,
    iconSize: [40, 67],
    iconAnchor: [20, 67],
    popupAnchor: [0, -45]
  });

const chooseIcon = ({ channel, active = false, emphasized = false }) => {
  const pinImage = active ? pin : disabledPin;
  return emphasized
    ? emphasizeIcon(pinImage, channel)
    : normalIcon(pinImage, channel);
};

class ChannelMap extends Component {
  render() {
    const { emphasize = [], channels, center, zoom } = this.props;

    return (
      <div className="channel-map">
        <Map
          center={center}
          zoom={zoom}
          zoomDelta={0.2}
          zoomSnap={0.2}
          maxZoom={13}
          minZoom={1.0}
        >
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MarkerClusterGroup>
            {channels.map((channel, i) => {
              const isEmphasized = emphasize.indexOf(channel) >= 0;
              const isActive = channel.status && channel.status.active;
              return (
                <Marker
                  key={i}
                  position={[channel.location.lat, channel.location.lng]}
                  icon={chooseIcon({
                    channel: channel.id,
                    active: isActive,
                    emphasized: isEmphasized
                  })}
                  zIndexOffset={
                    (isActive ? 100 : 0) + (isEmphasized ? 1000 : 0)
                  }
                >
                  <Popup>
                    <Link to={`/channel/${channel.id}`}>
                      {channel.location.name},{" "}
                      {iso.whereAlpha2(channel.location.country).alpha3}
                    </Link>
                  </Popup>
                </Marker>
              );
            })}
          </MarkerClusterGroup>
        </Map>
      </div>
    );
  }
}

export default ChannelMap;
